<template>
  <div>
    <b-button
      variant="warning"
      @click="downloadPdf"
    >
      Скачать в PDF
    </b-button>
    <div
      ref="pdfContent"
      class="d-flex flex-column"
    >
      <b-img
        class="mx-auto mt-2"
        :src="require('@/assets/images/logo/logoGrandCapital.svg')"
        width="150"
      />
      <p class="text-center mt-1 font-weight-bold">
        ДОГОВОР № {{ GET_ONE_CONTRACT.contract_number }}
      </p>
      <p class="text-center mt-1 mx-5 px-5 font-weight-bold">
        {{ GET_ONE_CONTRACT.document.header }}
      </p>
      <div
        class="mt-2 px-4 text-justify"
        v-html="GET_ONE_CONTRACT.document.main_part"
      />
      <section
        v-for="(clause, index) in GET_ONE_CONTRACT.document.clauses"
        :key="index"
        class="px-4 text-justify"
      >
        <p class="font-weight-bold text-center text-uppercase">
          {{ index + 1 }}. {{ clause.title }}
        </p>
        <b-row
          v-for="(subclause, ind) in clause.subclauses"
          :key="ind"
        >
          <b-col md="1">
            <p class="mb-0 font-weight-bold">
              {{ subclause.key }}
            </p>
          </b-col>
          <b-col
            md="11"
            v-html="subclause.value"
          />
        </b-row>
      </section>
      <section>
        <p class="font-weight-bold text-center text-uppercase">
          {{ GET_ONE_CONTRACT.document.clauses.length }}. ЮРИДИЧЕСКИЕ АДРЕСА
          СТОРОН
        </p>
        <b-row>
          <b-col md="6">
            <p class="font-weight-bold text-center text-uppercase">
              Застройщик
              <br>
              ООО {{ GET_ONE_CONTRACT.brand.title }}
            </p>
            <p>
              {{ GET_ONE_CONTRACT.brand.address }}
            </p>
            <p />
            <p>ИНН: {{ GET_ONE_CONTRACT.brand.account.inn }}</p>
            <p>ОКЕД: {{ GET_ONE_CONTRACT.brand.account.oked }}</p>
          </b-col>
          <b-col md="6">
            <p class="font-weight-bold text-center text-uppercase">
              ИНВЕСТОР
            </p>
          </b-col>
        </b-row>
        <p class="font-weight-bold text-center text-uppercase">
          ПОДПИСЫ СТОРОН
        </p>
        <div class="d-flex justify-content-between">
          <div class="border-top">
            {{ GET_ONE_CONTRACT.brand.boss }} Директор
          </div>
          <div class="border-top">
            {{ GET_ONE_CONTRACT.customer_details.name }}
          </div>
        </div>
      </section>
    </div>
    <!-- html2canvas: { scale: 1 }, -->
    <vue-html2pdf
      v-if="false"
      ref="html2Pdf"
      :html-to-pdf-options="{
        margin: [12, 0, 22, 0],
        image: { type: 'png', quality: 1 },
      }"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :filename="contractContent.contract_number"
      :pdf-quality="2"
      :manual-pagination="false"
      :paginate-elements-by-height="1350"
      pdf-format="a4"
      pdf-orientation="portrait"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      @beforeDownload="beforeDownload($event)"
    >
      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <div
          ref="pdfContent"
          class="d-flex flex-column"
        >
          <b-img
            class="mx-auto mt-2"
            :src="require('@/assets/images/logo/logoGrandCapital.svg')"
            width="150"
          />
          <p class="text-center mt-1 font-weight-bold">
            ДОГОВОР № {{ GET_ONE_CONTRACT.contract_number }}
          </p>
          <p class="text-center mt-1 mx-5 px-5 font-weight-bold">
            {{ GET_ONE_CONTRACT.document.header }}
          </p>
          <div
            class="mt-2 px-4 text-justify"
            v-html="GET_ONE_CONTRACT.document.main_part"
          />
          <section
            v-for="(clause, index) in GET_ONE_CONTRACT.document.clauses"
            :key="index"
            class="px-4 text-justify"
          >
            <p class="font-weight-bold text-center text-uppercase">
              {{ index + 1 }}. {{ clause.title }}
            </p>
            <b-row
              v-for="(subclause, ind) in clause.subclauses"
              :key="ind"
            >
              <b-col md="1">
                <p class="mb-0 font-weight-bold">
                  {{ subclause.key }}
                </p>
              </b-col>
              <b-col
                md="11"
                v-html="subclause.value"
              />
            </b-row>
          </section>
          <section class="px-4">
            <p class="font-weight-bold text-center text-uppercase">
              {{ GET_ONE_CONTRACT.document.clauses.length + 1 }}. ЮРИДИЧЕСКИЕ
              АДРЕСА СТОРОН
            </p>
            <b-row>
              <b-col
                v-if="GET_ONE_CONTRACT.brand"
                md="6"
              >
                <p class="font-weight-bold text-center text-uppercase">
                  Застройщик
                  <br>
                  ООО {{ GET_ONE_CONTRACT.brand.title }}
                </p>
                <p>
                  {{ GET_ONE_CONTRACT.brand.address }}
                </p>
                <p>Р/c: {{ GET_ONE_CONTRACT.requisite.account_number }}</p>
                <p>
                  {{ GET_ONE_CONTRACT.requisite.bank_name }}
                </p>
                <p>ЬФО: {{ GET_ONE_CONTRACT.requisite.mfo }}</p>
                <p>ИНН: {{ GET_ONE_CONTRACT.brand.account.inn }}</p>
                <p>ОКЕД: {{ GET_ONE_CONTRACT.brand.account.oked }}</p>
              </b-col>
              <b-col md="6">
                <p class="font-weight-bold text-center text-uppercase">
                  ИНВЕСТОР
                  <br>
                  <br>
                </p>
                <p>
                  {{ GET_ONE_CONTRACT.customer_details.name }}
                </p>
                <p>
                  Серия:
                  {{
                    GET_ONE_CONTRACT.customer_details.passport.seria +
                      GET_ONE_CONTRACT.customer_details.passport.number
                  }}
                </p>
                <p>
                  Кем выдан:
                  {{
                    GET_ONE_CONTRACT.customer_details.passport.passport_given_by
                  }}
                </p>
                <p>
                  Адрес по прописке:
                  {{ GET_ONE_CONTRACT.customer_details.passport.address }}
                </p>
                <p>ИНН: {{ GET_ONE_CONTRACT.customer_details.inn }}</p>
                <p>Телефон: {{ GET_ONE_CONTRACT.customer_details.phones }}</p>
              </b-col>
            </b-row>
            <p class="font-weight-bold text-center text-uppercase">
              ПОДПИСЫ СТОРОН
            </p>
            <div class="d-flex justify-content-between">
              <div class="border-top">
                {{ GET_ONE_CONTRACT.brand.boss }} Директор
              </div>
              <div class="border-top">
                {{}}
              </div>
            </div>
          </section>
        </div>
      </section>
    </vue-html2pdf>
    <!-- <div
      ref="footer"
      class="d-flex justify-content-between mx-5 pl-5"
    >
      <span>
        Rayimov X. D. Директор _____________
      </span>
      <span>
        ИНВЕСТОР_______________
      </span>
    </div> -->
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import {
  BImg,
  BRow,
  BCol,
  // BButton,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line
import { jsPDF } from "jspdf";
// import * as fontCyr from '@/assets/fonts/Tinos-Regular-normal'
// import * as font from '@/assets/fonts/times-new-roman-normal'
// eslint-disable-next-line
// import * as fontCyr from '@/assets/fonts/times-new-roman-cyr-normal'

export default {
  components: {
    VueHtml2pdf,
    BImg,
    BRow,
    BCol,
    // BButton,
  },
  props: {
    contractContent: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    contractId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters('contracts', ['GET_ONE_CONTRACT']),
  },
  async mounted() {
    await this.FETCH_ONE_CONTRACT(this.contractId || this.$route.params.id).then(() => {
      // this.$refs.html2Pdf.generatePdf()
      // console.log(this.$refs.pdfContent)
      // this.contractContent = this.GET_ONE_CONTRACT
    })
  },
  methods: {
    ...mapActions('contracts', ['FETCH_ONE_CONTRACT', 'EDIT_CONTRACT']),
    onProgress(event) {
      console.log(event)
    },
    hasStartedGeneration() {
      console.log('has started')
    },
    hasGenerated(event) {
      console.log(event)
    },
    downloadPdf() {
      console.log('generation')
      console.log(this.contractContent)
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload(event) {
      const blob = await event
        .html2pdf()
        .set(event.options)
        .from(event.pdfContent)
        .toPdf()
        .get('pdf')
        .then(pdf => {
          const totalPages = pdf.internal.getNumberOfPages()
          pdf.setFont('Tinos-Regular')
          // pdf.deletePage(1)
          for (let i = 1; i < totalPages; i += 1) {
            pdf.setPage(i)
            pdf.setFontSize(14)
            pdf.setTextColor(150)
            pdf.text(
              `${this.GET_ONE_CONTRACT.brand.boss} Директор _____________                      ИНВЕСТОР_______________`,
              pdf.internal.pageSize.getWidth() * 0.08,
              pdf.internal.pageSize.getHeight() - 10,
            )
            // pdf.text('dwdwdwdwd', (pdf.internal.pageSize.getWidth() * 0.08), (pdf.internal.pageSize.getHeight() - 10))
          }
        })
        // .save()
        .outputPdf('blob', 'cvfdsvdfvdfv.pdf')
      console.log(blob)
      const file = new File([blob], 'cdscsdcd.pdf')
      console.log(file)
      const fd = new FormData()
      fd.append('id', this.contractId)
      fd.append('file', file)
      this.EDIT_CONTRACT(fd).then(() => {
        this.$emit('generationEnd')
      })
    },

    convertToPdf() {
      // eslint-disable-next-line
      const doc = new jsPDF();
      doc.fromHTML(document.body, 15, 15, {
        width: 170,
        elementHandlers: {
          body: () => true,
        },
      })

      console.log('doc', doc)
    },
  },
}
</script>

<style lang="scss">
.pdf-content,
.font-family-times {
  font-family: "Times New Roman", Times, serif;
}
</style>
